import { render, staticRenderFns } from "./InboxListName.vue?vue&type=template&id=8557f7b6"
import script from "./InboxListName.vue?vue&type=script&lang=js"
export * from "./InboxListName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports